module.exports = __webpack_public_path__ + "img/odnoklassniki-circled.b6b380ae.png";